import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import LinkComponent from '../../../typography/Link';
import { sanitizeMarkdownUrl } from '../sanitizeUrl';

const validLinkAttributes = ['id', 'title'];

const Link = ({ callback, href, target, title, node: _node, ...otherProps }) => {
    const [finalTitle, setFinalTitle] = useState(undefined);
    const [attributes, setAttributes] = useState({});
    const safeHref = sanitizeMarkdownUrl(href);

    const handleClick = useCallback(
        (event) => {
            if (callback) {
                event.preventDefault();
                const link = () => {
                    if (!safeHref) return;
                    const finalTarget = target || attributes?.target;
                    if (!finalTarget || finalTarget === '_self') {
                        window.location.href = safeHref;
                    } else {
                        window.open(safeHref, finalTarget);
                    }
                };
                callback({ event, attributes, link });
            }
        },
        [attributes, callback, safeHref, target],
    );

    const parseTitleString = useCallback((str) => {
        try {
            const parsedJson = JSON.parse(str);
            const finalAttributes = Object.entries(parsedJson).reduce((acc, [key, value]) => {
                if (validLinkAttributes.includes(key)) {
                    acc[key] = value;
                }
                return acc;
            }, {});
            setAttributes(finalAttributes);
        } catch (error) {
            setFinalTitle(str);
        }
    }, []);

    useEffect(() => {
        title && parseTitleString(title);
    }, [parseTitleString, title]);

    const linkProps = useMemo(() => {
        const { id, ...otherAttrs } = attributes;
        return {
            target,
            title: finalTitle,
            onClick: handleClick,
            ...otherAttrs,
            ...otherProps,
            href: safeHref || undefined,
        };
    }, [attributes, finalTitle, handleClick, otherProps, safeHref, target]);

    return <LinkComponent {...linkProps} />;
};

export default memo(Link);
